import { getBackVersion } from '../../config';
import { ActivationProgressSnapshot } from '../../models/RentalPayment/ActivationProgress/ActivationProgress';
import api from '../api';

const getActivationProgress = (): Promise<ActivationProgressSnapshot> =>
    api.request<ActivationProgressSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/agent/rental/activation`,
    });

const createFreeTrialCreditTask = (): Promise<void> =>
    api.request<void>({
        method: 'POST',
        url: `${getBackVersion()}/agent/rental/activation`,
    });
export { getActivationProgress, createFreeTrialCreditTask };
